import React from 'react';
import SectionTitle from '../../elements/section-title/SectionTitle';

const Datas = [
    {
        id: 1,
        title: "Compromiso con tu crecimiento",
        para: "Nos involucramos en tu operación como aliados tecnológicos, ayudándote a crecer con herramientas que se adaptan a ti."
    },
    {
        id: 2,
        title: "Transparencia en todo momento",
        para: "Actuamos con claridad en nuestros procesos, costos y soluciones. Lo que ves, es lo que obtienes: sin sorpresas ni letras pequeñas."
    },
    {
        id: 3,
        title: "Innovación con propósito",
        para: "No solo creamos software: diseñamos soluciones que resuelven problemas reales y hacen más eficiente tu día a día."
    },
    {
        id: 4,
        title: "Cercanía y trato humano",
        para: "Más allá del soporte técnico, construimos relaciones de confianza. Escuchamos, comprendemos y actuamos contigo."
    },
    {
        id: 5,
        title: "Calidad como base del servicio",
        para: "Desde el código hasta la atención, buscamos siempre altos estándares para ofrecerte un sistema robusto, útil y confiable."
    }
]




const AboutThree = () => {
    return (
        <div className="section section-padding bg-color-dark pb--80 pb_lg--40 pb_md--20">
            <div className="container">
                <SectionTitle 
                    subtitle="Más que software, un aliado para hacer crecer tu empresa"
                    title="POR QUÉ SOFTWEB"
                    description="Te acompañamos desde la implementación hasta la operación diaria, con soluciones empresariales que se adaptan a tu negocio y un equipo que responde cuando lo necesitas."
                    textAlignment="heading-left heading-light-left mb--100"
                    textColor=""
                />

                <div className="row">
                    {Datas.map((data) => (
                        <div className="col-lg-4" key={data.id}>
                            <div className="about-quality">
                                <h3 className="sl-number">{data.id}</h3>
                                <h5 className="title">{data.title}</h5>
                                <p>{data.para}</p>
                            </div>
                        </div>
                    ))}

                </div>
            </div>
            <ul className="list-unstyled shape-group-10">
                <li className="shape shape-1"><img src={process.env.PUBLIC_URL + "/images/others/circle-1.png"} alt="Circle" /></li>
                <li className="shape shape-2"><img src={process.env.PUBLIC_URL + "/images/others/line-3.png"} alt="Circle" /></li>
                <li className="shape shape-3"><img src={process.env.PUBLIC_URL + "/images/others/bubble-5.png"} alt="Circle" /></li>
            </ul>
        </div>
    )
}

export default AboutThree;